import React from "react";
import "./Gallery.css";

const carParkingImages = [
  require("../assets/gallery/Parkingmgmt.jpg"),
  require("../assets/gallery/Parkingmgmt2.jpg"),
  require("../assets/gallery/Parkingmgmt3.jpg")
];

const otherGalleryImages = [
  require("../assets/gallery/SecurityGuards.jpg"),
  require("../assets/gallery/office.jpg"),
  // require("../assets/gallery/others/img3.jpg"),
  // require("../assets/gallery/others/img4.jpg"),
  // require("../assets/gallery/others/img5.jpg")
];

const Gallery = () => {
  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <h2>Car Parking Management</h2>
        <div className="gallery-grid">
          {carParkingImages.map((src, index) => (
            <div className="gallery-item" key={`car-${index}`}>
              <img src={src} alt={`Car Parking ${index + 1}`} />
            </div>
          ))}
        </div>

        <h2>Other Gallery Photos</h2>
        <div className="gallery-grid">
          {otherGalleryImages.map((src, index) => (
            <div className="gallery-item" key={`other-${index}`}>
              <img src={src} alt={`Gallery ${index + 1}`} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
